<template>
  <el-cascader :options="allDepartList" v-model="selectedOptions" @change="handleChange" placeholder="请选择机构" filterable change-on-select clearable></el-cascader>
</template>
<script>
export default {
  name: 'organizationalSelect',
  props: {
    depCode: {
      type: String
    }
  },
  data() {
    return {
      selectedOptions: [],
      allDepartList: []
    };
  },
  created() {
    // this.allDepartList.push(this.userInfor.departName);
  },
  methods: {
    handleChange(arr) {
      this.$emit('handleChange', arr);
    },
    async getAllDepartList() {
      const { bean } = await this.$services.post({
        type: 'ORGANIZATIONALMANAGEMENT',
        url: 'getAllDepartList'
      });
      this.allDepartList = this.transforTree(bean);
    },
    transforTree(treeData) {
      if (!treeData || treeData.length === 0) {
        return [];
      }
      const childs = [];
      treeData.forEach(tree => {
        if (tree.children) {
          childs.push({
            value: tree.depCode,
            label: tree.label,
            children: transforTree(tree.children)
          });
        }
        else {
          childs.push({
            value: tree.depCode,
            label: tree.label
          });
        }
      });
      return childs;
    }
  },
  created() {
    this.getAllDepartList();
  }
};
</script>
<style lang="scss" scoped>
.el-cascader {
  width: 100%;
}
</style>
